import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SessionsLayout } from '#modules/user/features/dashboard/components/SessionsLayout';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/sessions/_sessions'
)({
  component: LayoutComponent,
  ssr: false,
});

function LayoutComponent() {
  return (
    <SessionsLayout>
      <Outlet />
    </SessionsLayout>
  );
}
